<template>
    <div class="accordion" v-bind:class="{collapsed: collapsed}">
        <div class="accordion-title-wrap" @click="collapseAccordion()">
            <div class="accordion-title-wrap height-100 relative">
                <div class="flex-content">
                    <div class="width-100 relative">
                        <div class="accordion-title">
                            <slot name="accordion-title"></slot>
                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion-subtitle-wrap height-100 relative">
                <div class="flex-content">
                    <div class="width-100 relative">
                        <div class="accordion-subtitle">
                            <slot name="accordion-subtitle"></slot>
                        </div>
                    </div>
                </div>
            </div>
            <Button variant="icon-wrap" class="float-right"><svgicon name="chevron" /></Button>
        </div>
        <div class="accordion-content-wrap">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    import Button from '../../components/Button/Button'
    export default {
        name: 'Accordion',
        components: {
            Button
        },
        props: {
        },
        data () {
            return {
                collapsed: true
            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {
            collapseAccordion: function() {
                this.collapsed = !this.collapsed;
            }
        }
    }

</script>
<style src="./Accordion.scss" scoped lang="scss"></style>

